export default "__VITE_ASSET__2bd7cb43__"